import React from "react";
import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { Close } from "@material-ui/icons";
import SimpleAddProduct from "./SimpleAddProduct";

export default function SimpleAddProductModal({ open, handleClose, onSelect }) {
  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle sx={{ pb: 1 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Box>
            <Typography variant="h6">Nuevo producto complemento</Typography>
            <Typography variant="caption" color="text.secondary">
              Se añadirá directamente como opción seleccionable
            </Typography>
          </Box>
          <IconButton size="small" onClick={handleClose}>
            <Close fontSize="small" />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent dividers sx={{ pt: 2 }}>
        <SimpleAddProduct onClose={handleClose} onSelect={onSelect} />
      </DialogContent>
    </Dialog>
  );
}
